import { render } from "./ContractFormCard.vue?vue&type=template&id=039d550c&ts=true"
import script from "./ContractFormCard.vue?vue&type=script&lang=ts"
export * from "./ContractFormCard.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__